import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
/**
 * @template T
 * @typedef {import('@reduxjs/toolkit').DeepPartial<T>} DeepPartial<T>
 */

import { cartReducer } from '@src/Redux/Module/Cart';
import { appReducer } from '@src/Redux/Module/App';

const reducer = combineReducers({
    cart: cartReducer,
    app: appReducer,
});

/**
 * @typedef {ReturnType<typeof reducer>} OlsState
 */

/**
 * @param {DeepPartial<OlsState>=} initialState
 */
export const createOlsStore = (initialState = undefined) => configureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

/**
 * @typedef {ReturnType<createOlsStore>} OlsStore
 * @typedef {Extract<ReturnType<createOlsStore>, 'dispatch'>} OlsDispatch
 */
